module.exports = __webpack_public_path__ + "media/feature-icons/signature-dfdc3c31.png";